import React, { useState, useEffect, useRef } from 'react';

import { API } from 'aws-amplify';
import Icon from '@mdi/react';
import { mdiBellRing } from '@mdi/js';
import { mdiAlertCircleCheckOutline } from '@mdi/js';
import './NotifyMe.css';
import { Collapse } from 'reactstrap';
var serviceNames = require('../ServiceNameMapper');

const Notifications = () => {
    const collapsibleRef = useRef(null);
    const [collapse, setCollapse] = useState(false);
    const [dataloaded, setDataloaded] = useState(false);
    const [notificationcount, setNotificationcount] = useState(0);
    const [notifications, setNotifications] = useState([]);

    useEffect(() => {
        const timer = setInterval(() => {
            getNotifications();
            console.log("updateed notifications");
        }, 6000);
        return () => clearInterval(timer);
    }, []);

    useEffect(() => {
        getNotifications();
        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);

    const handleClickOutside = (event) => {
        if (collapsibleRef.current && !collapsibleRef.current.contains(event.target)) {
            setCollapse(false);
            global.$notificationCount += notificationcount
            setNotificationcount(0)
        }
    };

    const getNotifications = async () => {
        try {
            let apiName = serviceNames.getEventPlannerService();
            let path = ''; //replace this with the path you have configured on your API
            let myInit = {
                body: {
                    'code': global.$code,
                    'command': 'getNotifications',
                    'status': 'All'
                },
                response: true,
                convertEmptyValues: true,
                headers: {}
            };

            const response = await API.post(apiName, path, myInit);
            if (response.err == null && response.data != null) {

                if (notifications.length < response.data.data.length) {
                    const formattedNotifications = getNotificationsTableObjects(response.data.data);
                    
                    let notificationCount = formattedNotifications.length - global.$notificationCount;
                    if (notificationCount < 0) {
                        notificationCount = 0; // Prevent negative values
                    }

                    if (global.$clearnotification) {
                        const SpliceNotification = formattedNotifications.slice(global.$clearnotificationCount,formattedNotifications.length)
                        setNotifications(SpliceNotification);
                    }
                    else {
                        setNotifications(formattedNotifications);
                    }

                    setNotificationcount(notificationCount);

                } else {
                    setNotifications([]);
                }
                setDataloaded(true);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const getNotificationsTableObjects = (objs) => {
        const tableObjs = [];
        for (var i = 0; i < objs.length; i++) {
            var notificationObj = objs[i];
            var newObj = Object();
            if (notificationObj.nstatus.S === "L") {
                newObj.message = notificationObj.message.S;
                newObj.nid = notificationObj.nid.N;
                newObj.senddate = notificationObj.senddate.S
            } else {
                newObj.message = "";
                newObj.nid = "";
                newObj.senddate = "";
            }
            tableObjs.push(newObj);
        }
        const formattedNotifications = tableObjs.map(item => ({
            update: item.message,
            timestamp: Number(item.nid),
            senddate: item.senddate
        }));
        const uniqueNotifications = removeDuplicates(formattedNotifications, 'timestamp');
        return uniqueNotifications;
    };

    const removeDuplicates = (array, key) => {
        return array.filter((obj, index, self) =>
            index === self.findIndex((el) => (
                el[key] === obj[key]
            ))
        );
    };

    const toggle = () => {
        setCollapse(!collapse);
        global.$notificationCount += notificationcount
        setNotificationcount(0)
    };

    const clearNotifications = () => {
        global.$clearnotification = true;
        global.$clearnotificationCount = global.$notificationCount
        setNotifications([])
    }


    if (!dataloaded) {
        return <div></div>;
    }

    return (
        <div className='notification-div'>

            <div className='collapse-section' ref={collapsibleRef}>
                <button className="btn dot-btn notification-icon-button" onClick={toggle}>
                    <Icon path={mdiBellRing} size={1} color={'white'} />{notificationcount !== 0 && <span className='notification-count'>{notificationcount}</span>}
                </button>
                <Collapse isOpen={collapse} className={"wrapper-collapse"}>
                    <span className="notification-clear-button" onClick={clearNotifications}>Clear All</span>
                    {
                        notifications
                            ?.sort((a, b) => {
                                const dateA = new Date(a.senddate);
                                const dateB = new Date(b.senddate);
                                return dateB - dateA;
                            })
                            ?.map((notification, index) => {
                                return (
                                    <div key={index} className='notification-item'>
                                        <div className="">
                                            <Icon path={mdiAlertCircleCheckOutline} size={0.8} color={'#b3a668'} />
                                        </div>
                                        <div className='notification-item-text'>
                                            {notification.update}
                                            <span>{notification.senddate}</span>
                                        </div>

                                    </div>
                                );
                            })
                    }
                </Collapse>
            </div>
        </div>
    );
};

export default Notifications;


/**
 //import NotifyMe from 'react-notification-timeline';
old formate
<NotifyMe
                data={notifications}
                storageKey='notific_key'
                notific_key='timestamp'
                notific_value='update'
                heading={global.$header.menu.notifications.heading}
                //heading="Notifications"
                sortedByKey={false}
                showDate={true}
                //size={34}
                size={global.$header.menu.notifications.size}
                //color="yellow"
                color={global.$header.menu.notifications.color}
                className="menu-notification"
            /> 
 * 
 */